import { ApiResponse, CartAdded, AddToCartPayload, CartData, CartDeleted, DeleteCartItemPayload, CartPriceUpdate } from "../../../types";
import { deleteRequestWithAuth, getRequestWithAuth, postRequestWithAuth, Tparams } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V1);


export interface Cart{
    getCartItems(param:Tparams,pincode?:string): Promise<ApiResponse<CartData>>
    addToCart(cartPayload:AddToCartPayload, utmQuery:any):Promise<ApiResponse<CartAdded>>; 
    deleteCartItem(item_id:number):Promise<ApiResponse<CartDeleted>>
    updateCartPrice(pincode:string, sessionCode:string):Promise<ApiResponse<CartPriceUpdate>>
}

const cart: Cart = {
     getCartItems(parms,pincode) {
        const q = {pincode:pincode}
    return getRequestWithAuth(api.CART_ITEMS, parms,q)
  },
    addToCart(cartPayload, utmQuery ) {

        let requestQuery = utmQuery ? utmQuery : undefined;
        return postRequestWithAuth(api.CART_ADD_TO_CART, cartPayload, undefined, requestQuery)
    },
    deleteCartItem(item_id){
     
        return deleteRequestWithAuth(api.CART_DELETE_ITEMS,item_id)
    },

    updateCartPrice(pincode, sessionCode) {
        return getRequestWithAuth(api.CART_UPDATE_Price, [pincode, sessionCode])
    },
}

export default cart

